<template>
  <DataTable
    data-id="quotes-table"
    :disable-delete="true"
    :disable-edit="isChild || isVendor"
    :disable-new="true"
    :fields="fieldsQuotes"
    :items="quotes || []"
    :loading="loading"
    icon="quote"
    :no-card="noCard"
    disable-sort
    title="Quotes"
    @edit="onEditQuote"
    @refresh="refreshQuotes"
  />
</template>
<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';

import DataTable from '~/components/table/parts/DataTable.vue';
import { listQuotes } from '~/lib/services/fields';
import type { QuoteDto } from '@mailslurp/admin-sdk';
import { loadFetch } from '~/lib/services/helpers';

import { useStore3 } from '~/store/main';
import { storeToRefs } from 'pinia';
import { navigateTo } from '#imports';

const store3 = useStore3();

withDefaults(defineProps<{ noCard?: boolean }>(), {
  noCard: false,
});

const loading = ref(false);

const fieldsQuotes = ref(listQuotes);
const onEditQuote = async (payload: { item: QuoteDto }) => {
  await navigateTo(`/upgrade/quote/${payload.item.id}`);
};

const { allQuotes, isVendor, isChild } = storeToRefs(store3);

const quotes = computed<Array<QuoteDto> | null>(() => {
  return allQuotes.value?.items ?? [];
});

const refreshQuotes = async () => {
  await loadFetch(() => store3.getQuotes(), store3, loading);
};

onMounted(async () => {
  await refreshQuotes();
});
</script>
